module.exports = __webpack_public_path__ + "static/media/login_logo.01ab3517.png";